import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPbjs = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 13.8462,
			height: 1.15385,
			rx: .576923,
			transform: "matrix(1 0 0 -1 2.69238 13.0762)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 1.15385,
			rx: .576923,
			transform: "matrix(1 0 0 -1 6.1543 16.5391)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 20.7692,
			height: 1.15385,
			rx: .576923,
			transform: "matrix(1 0 0 -1 1.53809 20)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 20.7692,
			height: 1.15385,
			rx: .576923,
			transform: "matrix(1 0 0 -1 2.8457 9.61523)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 18.4615,
			height: 1.15385,
			rx: .576923,
			transform: "matrix(1 0 0 -1 0.384766 6.1543)"
		})
	]
});
export default SvgPbjs;
